<script lang="ts">
  import cx from "classnames";
  import type { ToolOption } from "./toolConstants";

  export let items: ToolOption[];
  export let command: ({ result }: { result: ToolOption }) => void;

  let selectedIndex = 0;

  const onKeyDown = (event: { key: string }) => {
    if (event.key === "ArrowUp") {
      selectedIndex = (selectedIndex + items.length - 1) % items.length;
      return true;
    }

    if (event.key === "ArrowDown") {
      selectedIndex = (selectedIndex + 1) % items.length;
      return true;
    }

    // scroll the selected item into view
    document
      .querySelector(`[data-item="${selectedIndex}"]`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });

    if (event.key === "Enter") {
      selectItem(selectedIndex);
      return true;
    }
    return false;
  };

  const selectItem = (index: number) => {
    const item = items[index];
    if (item) {
      command({ result: item });
    }
  };
</script>

<svelte:window on:keydown={onKeyDown} />

<div
  class="max-h-[400px] min-w-[300px] space-y-1 overflow-y-auto rounded-lg border border-neutral-300 bg-white p-1 drop-shadow-lg focus:outline-none dark:border-neutral-600 dark:bg-neutral-700"
>
  <div class="ml-0.5 p-2 text-sm font-medium text-neutral-500 dark:text-neutral-400">Tools</div>
  {#each items as item, index (item)}
    <button
      data-item={index}
      class={cx(
        "group inline-flex w-full cursor-pointer items-start rounded-md p-2 text-neutral-500 hover:bg-neutral-100 hover:text-neutral-600 dark:text-neutral-300 dark:hover:bg-white/10 dark:hover:text-neutral-200",
        {
          "active bg-neutral-100 text-neutral-600 dark:bg-white/10 dark:text-neutral-200":
            index === selectedIndex,
        }
      )}
      on:click|preventDefault|stopPropagation={() => selectItem(index)}
    >
      <span class="font-inter font-medium">{item}</span>
    </button>
  {:else}
    <div class="mx-0.5 p-2 text-sm font-medium dark:text-neutral-400">No tools found</div>
  {/each}
</div>
